import React, { createContext, useContext } from "react";
import { oneOf, useViewState } from "utils/useViewState";
import { ALL_LOCALES, DEFAULT_LOCALE } from "./constants";

type ActiveLocaleContextValue = {
  activeLocale: string;
  setActiveLocale: (locale: string) => void;
};

const ActiveLocaleContext = createContext<ActiveLocaleContextValue>({
  activeLocale: DEFAULT_LOCALE,
  setActiveLocale: () => {},
});

export const ActiveLocaleProvider: React.FC<{ children: React.ReactNode; inUrl?: boolean }> = ({
  children,
  inUrl = true,
}) => {
  const [{ locale }, set] = useViewState({ locale: DEFAULT_LOCALE }, { inUrl });
  const activeLocale = oneOf(ALL_LOCALES, locale, DEFAULT_LOCALE);
  const setActiveLocale = (next: string) => set({ locale: next });
  return (
    <ActiveLocaleContext.Provider value={{ activeLocale, setActiveLocale }}>{children}</ActiveLocaleContext.Provider>
  );
};

export const useActiveLocale = () => useContext(ActiveLocaleContext);
